export const socialChannels = [
    'TWITTER TWEET',
    'TWITTER DM',
    'FACEBOOK MESSENGER',
    'FACEBOOK POST',
    'INSTAGRAM IG-DM',
    'INSTAGRAM IG-COMMENT',
    'WHATSAPP WHATSAPP-DM',
    'SMS SMS-DM',
    'SMS OUTBOUND',
    'SMS CAMPAIGN-MESSAGE',
    'SMS MARKETING-MESSAGE'
];

export const voiceChannels = ['VOICE INBOUND', 'VOICE OUTBOUND', 'VOICE TRANSFER', 'VOICE DISCONNECT', 'VOICE MONITOR'];

export const webchatChannels = ['WEBCHAT'];

export const taskChannels = ['TASK INBOUND', 'TASK OUTBOUND', 'TASK CCREPLY', 'TASK'];

// these attributes define what is used in the Contact History tab switcher
export const contactHistoryAttributeKey = 'sa-contactHistorySearchKey';
export const contactHistoryAttributeValue = 'sa-contactHistorySearchValue';
export const contactHistoryAttributeDisplayLabel = 'sa-contactHistoryDisplayLabel';
export const channelTypes = {
    UNKNOWN: 'UNKNOWN',
    'TWITTER TWEET': 'TWITTER TWEET',
    'TWITTER DM': 'TWITTER DM',
    'FACEBOOK MESSENGER': 'FACEBOOK MESSENGER',
    'FACEBOOK POST': 'FACEBOOK POST',
    'INSTAGRAM IG-DM': 'INSTAGRAM IG-DM',
    'INSTAGRAM IG-COMMENT': 'INSTAGRAM IG-COMMENT',
	'WHATSAPP WHATSAPP-DM': 'WHATSAPP WHATSAPP-DM',
	'SMS SMS-DM': 'SMS SMS-DM',
    'SMS OUTBOUND': 'SMS OUTBOUND',
    'SMS CAMPAIGN-MESSAGE': 'SMS CAMPAIGN-MESSAGE',
    'SMS MARKETING-MESSAGE': 'SMS MARKETING-MESSAGE',
    'VOICE TRANSFER': 'VOICE TRANSFER',
    'VOICE INBOUND': 'VOICE INBOUND',
    'VOICE OUTBOUND': 'VOICE OUTBOUND',
    'VOICE DISCONNECT': 'VOICE DISCONNECT',
    'VOICE MONITOR': 'VOICE MONITOR',
    WEBCHAT: 'WEBCHAT',
    'TASK INBOUND': 'TASK INBOUND',
    'TASK OUTBOUND': 'TASK OUTBOUND',
    'TASK CCREPLY': 'TASK CCREPLY',
    TASK: 'TASK',
} as const;
